import { Select } from 'antd';
import '../../style/forms/Select/Select.less';

export default Select;